import React, {memo} from 'react';
import Tariffs from '../../components/Tariffs/Tariffs';
import {t} from '../../services/i18nHandler';

function LandingPageTariffsSection() {
  return (
    <div className="section section--tariffs" data-anchor="tariffs">
      <div className="section--tariffs--content">
        <div className="section--container">
          <div className="section--slogan">{t('landingPage.tariffs.slogan')}</div>
          <div className="section--title">{t('landingPage.tariffs.title')}</div>
          <Tariffs landing />
        </div>
      </div>
    </div>
  );
}

export default memo(LandingPageTariffsSection);
